export const API_PATH = process.env.REACT_APP_API_HOST;
export const INFURA_ID = process.env.REACT_APP_INFURA_ID;
export const ADDRESS = process.env.REACT_APP_ADDRESS;

export const NETWORK_MAP = {
    1: 'Mainnet',
    3: 'Ropsten',
    4: 'Rinkeby',
};
